import STORE from "./store";

export default STORE;
